import React, { Component } from 'react';
import { Alert as BSAlert } from 'react-bootstrap';
import '../css/App.css';

export default class Alert extends Component {
    render() {

        if(this.props.statusRequest === 200 ){
            return (
                <BSAlert bsStyle="success">
                    <strong>Show!</strong> {this.props.message}
                </BSAlert>
            );
        }

        if(this.props.statusRequest === 500 ){
            return (
                <BSAlert bsStyle="danger">
                    <strong>Ops!</strong> {this.props.message}
                </BSAlert>
            );
        }

        return '';
    }
}


// WEBPACK FOOTER //
// ./src/components/Alert.js